module.exports = __webpack_public_path__ + "static/media/escritorio.6d403ea9.svg";